import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { getConsent, onOpenCookieSettings, saveConsent } from '../../../helpers/cookieConsent'

const CookieBanner: React.FC = () => {
    const stored = getConsent()
    const [open, setOpen] = useState(!stored)
    const [showOptions, setShowOptions] = useState(false)
    const [analytics, setAnalytics] = useState(stored?.analytics ?? false)
    const [marketing, setMarketing] = useState(stored?.marketing ?? false)

    useEffect(() => {
        return onOpenCookieSettings(() => {
            const current = getConsent()
            setAnalytics(current?.analytics ?? false)
            setMarketing(current?.marketing ?? false)
            setShowOptions(true)
            setOpen(true)
        })
    }, [])

    if (!open) return null

    const choose = (choice: { analytics: boolean; marketing: boolean }) => {
        setOpen(false)
        setShowOptions(false)
        saveConsent(choice)
    }

    return (
        <div className={styles.cookieBanner} role="dialog" aria-live="polite" aria-label="Cookie preferences">
            <div className={styles.inner}>
                <p className={styles.text}>
                    We use essential cookies to run this site, and with your consent, analytics and marketing cookies to
                    improve it and measure our ads.{' '}
                    <a href="https://www.sentinellegal.co.uk/privacy-policy" target="_blank" rel="noreferrer">
                        Privacy Policy
                    </a>
                </p>

                {showOptions && (
                    <div className={styles.options}>
                        <label className={styles.option}>
                            <input type="checkbox" checked disabled />
                            <span>
                                <strong>Essential</strong> — needed for the claim form to work. Always on.
                            </span>
                        </label>
                        <label className={styles.option}>
                            <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} />
                            <span>
                                <strong>Analytics</strong> — Mouseflow records how visitors use the site so we can
                                improve it.
                            </span>
                        </label>
                        <label className={styles.option}>
                            <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
                            <span>
                                <strong>Marketing</strong> — Meta Pixel shares visits and claim submissions with Meta to
                                measure our adverts.
                            </span>
                        </label>
                    </div>
                )}

                <div className={styles.actions}>
                    <button type="button" className={styles.button} onClick={() => choose({ analytics: true, marketing: true })}>
                        Accept all
                    </button>
                    <button type="button" className={styles.button} onClick={() => choose({ analytics: false, marketing: false })}>
                        Reject all
                    </button>
                    {showOptions ? (
                        <button type="button" className={styles.linkButton} onClick={() => choose({ analytics, marketing })}>
                            Save choices
                        </button>
                    ) : (
                        <button type="button" className={styles.linkButton} onClick={() => setShowOptions(true)}>
                            Manage choices
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}

export default CookieBanner
